import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { NoAccessText } from 'components/layout';

interface GuardProps {
  hasAccess: boolean;
  redirectPath?: string;
  fallback?: boolean;
  children: ReactNode;
}

const Guard: FC<GuardProps> =
  ({
     hasAccess,
     redirectPath,
     fallback,
     children,
   }) => {
    const navigate = useNavigate();

    useEffect(() => {
      if (!hasAccess && !fallback) {
        navigate(redirectPath ?? '/cabinet/facebook/overview', { replace: true });
      }
    }, [hasAccess, navigate, redirectPath, fallback]);

    if (!hasAccess && fallback) {
      return <NoAccessText />;
    }

    return hasAccess && <>{children}</>;
  };

export default Guard;
